import { Container, Grid } from '@mui/material';
import './bidask.css'

import BaseComBidaskV4 from './BaseComBidaskV4';


const BidAskComponentOld2V4 = () => {

    return (
        <Grid>
            <Container maxWidth="xl" sx={{ flex: 1, display: 'flex', flexDirection: 'column', marginTop: 10, }}>
                <Grid container display="flex" alignItems="center" marginBottom={10}>
                    <Grid sm={6} paddingX={2}>
                        {BaseComBidaskV4(1)}
                    </Grid>
                    <Grid sm={6} paddingX={2}>
                        {BaseComBidaskV4(2)}
                    </Grid>
                </Grid>
            </Container>
        </Grid >
    );
};

export default BidAskComponentOld2V4;
